import { Controller } from "@hotwired/stimulus"

// Generic show/hide overlay for the email-capture card. Unlike
// tracker-check-email (which removes itself on close), this swaps
// hidden <-> flex so the modal can be reopened. Named tracker-modal
// because "modal" is taken by tailwindcss-stimulus-components.
export default class extends Controller {
  static targets = ["overlay"]

  open() {
    this.overlayTarget.classList.replace("hidden", "flex")
    this.overlayTarget.querySelector("input[type=email]")?.focus()
  }

  close() {
    this.overlayTarget.classList.replace("flex", "hidden")
  }

  backdrop(event) {
    if (event.target === event.currentTarget) this.close()
  }
}
